// extracted by mini-css-extract-plugin
export const searching = "spinner-module--searching--4nOkn";
export const load2 = "spinner-module--load2--bE-0x";
export const spinner = "spinner-module--spinner--3l9g0";
export const load1 = "spinner-module--load1--1XTsL";